import { Link } from "react-router-dom"
import { getToolBySlug } from "../toolRegistry"

export default function RelatedToolsList({ relatedSlugs }: { relatedSlugs: string[] }) {
  if (!relatedSlugs || relatedSlugs.length === 0) return null

  const tools = relatedSlugs
    .map((slug) => getToolBySlug(slug))
    .filter(Boolean) as NonNullable<ReturnType<typeof getToolBySlug>>[]

  if (tools.length === 0) return null

  return (
    <div className="mt-16 pt-12 border-t border-slate-200">
      <h2 className="text-xl font-bold text-slate-900 mb-6">You Might Also Like</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {tools.map((tool) => {
          const Icon = tool.icon
          return (
            <Link
              key={tool.slug}
              to={`/tools/${tool.slug}`}
              className="group bg-white border border-slate-200 rounded-xl p-4 flex flex-col hover:shadow-md hover:border-primary/50 transition-all"
            >
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 rounded-lg bg-slate-50 text-slate-600 group-hover:bg-primary/10 group-hover:text-primary transition-colors">
                  <Icon className="w-4 h-4" />
                </div>
                <h3 className="font-semibold text-slate-900 text-sm">{tool.shortTitle}</h3>
              </div>
              <p className="text-xs text-slate-500 line-clamp-2 mt-auto">
                {tool.description}
              </p>
            </Link>
          )
        })}
      </div>
    </div>
  )
}
